export default "__VITE_ASSET__DA_7PgOd__"